import { render, staticRenderFns } from "./DmqCartRetailerSection.vue?vue&type=template&id=2ce8a381&"
import script from "./DmqCartRetailerSection.vue?vue&type=script&lang=ts&"
export * from "./DmqCartRetailerSection.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports